import React from "react"
import styled, { css } from "styled-components"
import { Link } from "gatsby"

import { Settings } from "../../../styles/theme"

export const Button = styled.button`
  position: relative;
  height: 100%;
  padding: 1rem 1.5rem;
  border: 1px transparent;
  font-size: 1rem;
  border-radius: 5px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  color: ${Settings.primaryColor};
  background: none;
  transition: all 175ms ease-in-out;
  ${props =>
    props.type
      ? props.type === "solid"
        ? css`
            ${solidStyle}
          `
        : css`
            ${whiteStyle}
          `
      : css`
          ${defaultStyle}
        `}
`

const defaultStyle = `
  border: 1px solid ${Settings.primaryColor};
  &:hover {
    background: ${Settings.primaryColor};
    color: #fff;
  }
`

const whiteStyle = `
  border: 1px solid white;
  color: #fff;
`

const solidStyle = `
  background: ${Settings.primaryColor};
  color: #fff;
  &:hover {
    opacity: 0.7;
  }
`

const trackClick = track => {
  if (typeof window !== "undefined") {
    const dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())
    gtag("config", "DC-6953330")
    gtag("event", "conversion", {
      send_to: track,
    })
  }
}

export const ButtonLink = ({ text, slug, type, external, track }) => {
  return external ? (
    <p
      target="_blank"
      style={{ opacity: 1 }}
      onClick={
        typeof window !== "undefined"
          ? track
            ? () => {
                window.open(slug)
                trackClick(track)
              }
            : () => {
                window.open(slug)
              }
          : ""
      }
    >
      <Button type={type}>{text}</Button>
    </p>
  ) : (
    <>
      {/^(http|https):/.test(slug) === true ? (
        <p
          target="_blank"
          style={{ opacity: 1 }}
          onClick={
            typeof window !== "undefined"
              ? () => {
                  window.open(slug)
                }
              : ""
          }
        >
          <Button type={type}>{text}</Button>
        </p>
      ) : (
        <Link to={slug}>
          <Button type={type}>{text}</Button>
        </Link>
      )}
    </>
  )
}
